import { render, staticRenderFns } from "./open_member.vue?vue&type=template&id=5241caae&scoped=true&"
import script from "./open_member.vue?vue&type=script&lang=js&"
export * from "./open_member.vue?vue&type=script&lang=js&"
import style0 from "./open_member.vue?vue&type=style&index=0&id=5241caae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241caae",
  null
  
)

export default component.exports